module.exports = __webpack_public_path__ + "static/media/ethereumNew.dadbeae8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/ethereumNew.svg
// module id = 2448
// module chunks = 7